function isDarkMode() {
    return typeof document !== "undefined" && document.querySelector("link#dark_mode-css") !== null;
}
export { isDarkMode };
